import { TBorderStyle, TBorderWeight } from './TableNode';

const BORDER_WEIGHT_ORDER: Record<TBorderWeight, number> = {
  '0.5pt': 0,
  '1pt': 1,
  '2pt': 2,
  '3pt': 3,
};

export const MIN_RENDERABLE_DOUBLE_BORDER_WEIGHT: TBorderWeight = '3pt';

export const isWeightSupportedForStyle = (style: TBorderStyle | null | undefined, weight: TBorderWeight): boolean => {
  if (style !== 'double') {
    return true;
  }

  return BORDER_WEIGHT_ORDER[weight] >= BORDER_WEIGHT_ORDER[MIN_RENDERABLE_DOUBLE_BORDER_WEIGHT];
};
